export default __webpack_public_path__ + "static/media/sun-or-moon.e8b3bf60.svg";